import React from "react";
import "./Footer.css";

function Footer() {
  return (
    <footer className="d-flex footer-room justify-content-center  mt-2">
      <p>© 2024 &nbsp; The Majestic Hotel England. All Rights Reserved.</p>
    </footer>
  );
}

export default Footer;
